//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";

export default {
  name: 'nowplaying',
  data: function() {
    return {
      filename: ""
    }
  },
  methods: {
    async getFilename(trackid) {
      const trackdata = (await axios.get("https://webcenter.sisyphus-industries.com/tracks/" + trackid + ".json", { headers: {Authorization: this.$root.community.authToken }})).data;
      this.filename = trackdata.name;
    }
  },
}
